import React from 'react';
import { useQueries } from '@magoosh/gre/app/queries';
import TopicSlice, { TopicSegment } from '../../../../organisms/topic_slice';
import StatusMessage from '../../../../lib/status_message';
import { TopicSliceProps } from '../../../../organisms/topic_slice/types';

export const MathContent: React.FC = () => {
  const query = useQueries().topicsQuery('math');

  const processData = (subsections) => {
    const reducedData = subsections.reduce(
      (reducedTopics, topic) => {
        reducedTopics[topic.isStrategyFocused ? 0 : 1].push(topic);
        return reducedTopics;
      },
      [[], []]
    );
    return reducedData;
  };

  if (query.isLoading) {
    return (
      <StatusMessage
        headline="One Second!"
        isColored
        text="We are looking for math topics"
      />
    );
  } else {
    const [strategyData, topicsData] = processData(query.data);

    return (
      <>
        <h3 className="u-margin-V-m">All Math Topics</h3>

        <TopicSlice
          icon="Strategy"
          name="Strategies"
          subheadline={
            <>
              These topics teach you the strategies you’ll need to avoid pitfalls and save time no matter how
              confident you may or may not be in the subject matter.
            </>
          }>
          {strategyData.map((topic) => (
            <div key={topic.id} className="u-margin-B-xl">
              <h4 className="u-margin-A-n">
                <strong>{topic.name}</strong>
              </h4>
              {topic.segments.map((segment) => (
                <TopicSegment
                  key={segment.id}
                  {...segment}
                  relevanceToUser={topic.relevanceToUser}
                  userPerformanceScore={topic.userPerformanceScore}
                  isTooEarlyToTell={
                    topic.userPerformanceScoreIsAssumed ||
                    topic.userPerformanceScore === 0 ||
                    topic.userPerformanceScore === 1
                  }
                  subsection="math"
                />
              ))}
            </div>
          ))}
        </TopicSlice>

        {topicsData.map((topic) => (
          <TopicSlice
            key={topic.id}
            icon={`${topic.significanceLevel}Significance` as TopicSliceProps['icon']}
            {...topic}
            subsection="math"
          />
        ))}
      </>
    );
  }
};

export default MathContent;
